"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hslToHsla = void 0;
var tslib_1 = require("tslib");
var hslToHsla = function (_a, a) {
    var _b = tslib_1.__read(_a, 3), h = _b[0], s = _b[1], l = _b[2];
    if (a === void 0) { a = 1; }
    return [h, s, l, a];
};
exports.hslToHsla = hslToHsla;
